<template>
  <div>
    <v-btn
      x-small
      rounded
      :color="category.style.fill"
      :style="'opacity:' + category.style['fill-opacity'] + ';'"
      class="metadata-btn"
    ></v-btn>
    {{ category.label }}
  </div>
</template>

<script>
export default {
  name: 'CategoryLegend',
  props: {
    category: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style></style>
